import React from "react";
import { hydrate, render } from "react-dom";
import smoothscroll from "smoothscroll-polyfill";

import App from "./App";

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

smoothscroll.polyfill();
